import styled from "styled-components";
import { mobile } from "../utilities/responsive";


const Title = styled.h2`
  position: absolute;
  top: 200px;
  left: 60px;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #3c3c38;

  ${mobile({
    top: "58px",
    left: "calc(5vw + 10px)",
    gap: "10px",
    fontSize: "0.78rem",
  })}
`;

const Hairline = styled.span`
  width: 44px;
  height: 1px;
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.3);

  ${mobile({
    width: "26px",
  })}
`;

const Dot = styled.span`
  width: 5px;
  height: 5px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #990000;
`;

const Overline = ({ text }) => (
  <Title>
    <Hairline />
    <Dot />
    {text}
    <Dot />
    <Hairline />
  </Title>
);

export default Overline;